<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on: tooltip }">
      <v-dialog v-model="dialogConfirm" persistent max-width="290">
        <template v-slot:activator="{ on: dialog, attrs }">
          <v-btn
            icon
            text
            :color="esPropuestaActiva ? 'error' : 'success'"
            v-bind="attrs"
            v-on="{ ...tooltip, ...dialog }"
          >
            <v-icon
              >mdi-{{
                esPropuestaActiva ? 'clipboard-remove' : 'clipboard-check'
              }}</v-icon
            >
          </v-btn>
        </template>
        <v-card>
          <v-card-title class="text-h5"> Confirmar Acción </v-card-title>
          <v-card-text
            >La propuesta cambiará al estado
            <span
              class="font-weight-bold"
              :class="esPropuestaActiva ? 'error--text' : 'success--text'"
              >{{ esPropuestaActiva ? 'INACTIVO' : 'ACTIVO' }}</span
            >
            y
            <span class="font-weight-bold">{{
              esPropuestaActiva ? 'NO' : 'Sí'
            }}</span>
            podrá ser visto por los usuarios de la plataforma.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              :color="esPropuestaActiva ? 'error' : 'success'"
              text
              :loading="isLoading"
              :disabled="isLoading"
              @click="cambiarEstadoPropuesta"
            >
              Confirmar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <span>{{ esPropuestaActiva ? 'Desactivar' : 'Activar' }} Propuesta</span>
  </v-tooltip>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: ['propuesta'],

  data() {
    return {
      dialogConfirm: false,
      isLoading: false
    }
  },

  computed: {
    esPropuestaActiva() {
      if (this.propuesta) return this.propuesta.estadoTrabajo === 'ACTIVO'
      return false
    }
  },

  methods: {
    async cambiarEstadoPropuesta() {
      this.isLoading = true
      let body = {
        idTrabajo: this.propuesta._id,
        status: this.esPropuestaActiva ? 'INACTIVO' : 'ACTIVO'
      }
      await this.fetchCambiarEstadoPropuesta(body)
      this.isLoading = false
      this.dialogConfirm = false
      this.$emit('update-list')
    },

    ...mapActions('company', ['fetchCambiarEstadoPropuesta'])
  }
}
</script>

<style>
</style>